module.exports = __webpack_public_path__ + "static/media/input1.b26b42c0.jpg";